import { useQuery } from "@tanstack/react-query";
import { SupportCaseService } from "@/services/support/supportCaseService";
import { useAuth } from "@/hooks/useAuth";
import { UserType } from "@/types/user";

export function useSupportUnread() {
  const { user } = useAuth();
  const isAdmin = user?.type === UserType.Admin;

  return useQuery({
    queryKey: ["supportUnreadSummary", user?.id, isAdmin],
    queryFn: () => SupportCaseService.getUnreadSummary(isAdmin),
    enabled: !!user?.id,
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
  });
}
